module.exports = __webpack_public_path__ + "static/media/Group 2058@3x.df94e016.png";